import ActionTypes from './ActionTypes';
import { Location } from './Location';

export interface State {
	backlinks: Location[];
}

type Action = { type: ActionTypes.push; location: Location } | { type: ActionTypes.pop };

function createState(): State {
	return {
		backlinks: [],
	};
}

export default function reducer(state: State = createState(), action: Action): State {
	switch (action.type) {
		case ActionTypes.push:
			return { ...state, backlinks: [...state.backlinks, action.location] };

		case ActionTypes.pop: {
			const backlinks = [...state.backlinks];
			backlinks.pop();
			return { ...state, backlinks };
		}

		default:
			return state;
	}
}
